import styled from "styled-components";

export const BonusAndCashBalanceBox = styled.div`
    /* .bonus-and-cash-balance */
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 1rem 0;
    font-family: ${({theme}) => theme.font.family.body};;
    font-size: 1.4rem;
    letter-spacing: 1px;
    border-top: 1px solid #303030;
    border-bottom: 1px solid #303030;
`;
